// Remplacement minimal de vue-shortkey, compatible avec la syntaxe
// v-shortkey="['alt','o']" + @shortkey="...".
// Matche sur event.code (KeyO, Digit3...) au lieu de event.key, pour que
// Alt/Option+lettre fonctionne sur macOS peu importe la disposition clavier.

const bindings = {}; // combo normalisé -> [éléments liés]

function normalizeCombo(value) {
  const mods = { shift: false, ctrl: false, meta: false, alt: false };
  const keys = [];
  for (const part of value) {
    const p = String(part).toLowerCase();
    if (p in mods) mods[p] = true;
    else keys.push(p);
  }
  return ["shift", "ctrl", "meta", "alt"].filter((m) => mods[m]).concat(keys.sort()).join("+");
}

function comboFromEvent(e) {
  let key = "";
  if (/^Key[A-Z]$/.test(e.code)) key = e.code.slice(3).toLowerCase();
  else if (/^Digit\d$/.test(e.code)) key = e.code.slice(5);
  else if (/^F\d{1,2}$/.test(e.code)) key = e.code.toLowerCase();
  else return null;
  const mods = [];
  if (e.shiftKey) mods.push("shift");
  if (e.ctrlKey) mods.push("ctrl");
  if (e.metaKey) mods.push("meta");
  if (e.altKey) mods.push("alt");
  return mods.concat(key).join("+");
}

function onKeydown(e) {
  // AltGr (clavier CA-FR/international sur Windows) est vu comme Ctrl+Alt :
  // on le laisse passer pour ne pas bloquer la saisie de caractères spéciaux.
  if ((e.ctrlKey && e.altKey) || e.getModifierState("AltGraph")) return;
  const combo = comboFromEvent(e);
  if (!combo || !bindings[combo] || bindings[combo].length === 0) return;
  e.preventDefault();
  e.stopPropagation();
  const elements = bindings[combo];
  elements[elements.length - 1].dispatchEvent(new CustomEvent("shortkey"));
}

export default {
  install(Vue) {
    document.addEventListener("keydown", onKeydown, true);
    Vue.directive("shortkey", {
      bind(el, binding) {
        const combo = normalizeCombo(binding.value);
        el._shortkeyCombo = combo;
        (bindings[combo] = bindings[combo] || []).push(el);
      },
      unbind(el) {
        const combo = el._shortkeyCombo;
        if (!combo || !bindings[combo]) return;
        const idx = bindings[combo].indexOf(el);
        if (idx !== -1) bindings[combo].splice(idx, 1);
        delete el._shortkeyCombo;
      },
    });
  },
};
